import { Modal } from "components/ui/modals/Modal/Modal"
import { ButtonSecondary } from "components/ui/buttons/ButtonSecondary/ButtonSecondary"
import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import style from "./UnsavedChangesModal.module.scss"

const { text, buttons } = style

type Props = {
	isModalOpen: boolean
	onCancel: () => void
	onCloseWithoutSaving: () => void
	onSave: () => void
	isSaving?: boolean
}

export const UnsavedChangesModal = ({ isModalOpen, onCancel, onCloseWithoutSaving, onSave, isSaving }: Props) => {
	return (
		<Modal title="Save changes?" isModalOpen={isModalOpen} setModalClose={onCancel} width={456}>
			<p className={text}>Your changes will be lost if you don’t save them.</p>
			<div className={buttons}>
				<ButtonSecondary type="button" onClick={onCancel}>
					Cancel
				</ButtonSecondary>
				<ButtonSecondary type="button" onClick={onCloseWithoutSaving}>
					Don't save
				</ButtonSecondary>
				<ButtonPrimary onClick={onSave} submittable={!isSaving}>
					Save
				</ButtonPrimary>
			</div>
		</Modal>
	)
}
